import React from 'react';
import { audiLightTheme } from '../../themes';
import { ThemeProvider } from '../ThemeProvider';
import { GlobalStyles } from '../GlobalStyles';
import { audiPlatformProviderPropTypes, } from './PlatformProvider.types';
export const AudiPlatformProvider = ({ theme = audiLightTheme, children, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, null),
        React.createElement(ThemeProvider, { theme: theme }, children)));
};
AudiPlatformProvider.propTypes = audiPlatformProviderPropTypes;
//# sourceMappingURL=PlatformProvider.js.map